export const environment={
    local_public_endpoint:"http://localhost:8080/public",
    local_private_endpoint:"http://localhost:8080"
}